export const PROJECTS_SHARD = 'projects_shard';
export const AUTH = 'auth';
